import React from 'react'
import PropTypes from 'prop-types'

import loadable from '@loadable/component'
import CalloutBlock from 'js/pages/DatoPage/blocks/CalloutBlock'
import TextBlock from 'js/pages/DatoPage/blocks/TextBlock'
import ImageBlock from 'js/pages/DatoPage/blocks/ImageBlock'
import ListWithIconsBlock from 'js/pages/DatoPage/blocks/ListWithIconsBlock'
import RecipeTeaserBlock from 'js/pages/DatoPage/blocks/RecipeTeaserBlock'

const WidgetBlock = loadable(() =>
  import('js/components/WidgetBlock/WidgetBlock'),
)

const TestimonialsBlock = loadable(() =>
  import('js/pages/DatoPage/blocks/TestimonialsBlock.tsx'),
)

const Review = loadable(() => import('../Review'))

function ReviewBlock({ rating, reviewText, reviewer }) {
  return (
    <div className="mx-auto mb-24 w-4/5 lg:mb-36">
      <Review rating={rating} text={reviewText} reviewer={reviewer} />
    </div>
  )
}

ReviewBlock.propTypes = {
  rating: PropTypes.number,
  reviewText: PropTypes.string,
  reviewer: PropTypes.string,
}

const blocks = {
  TextBlockRecord: function TextBlockMargin(props) {
    return (
      <div className="my-64">
        <TextBlock {...props} />
      </div>
    )
  },
  WidgetRecord: WidgetBlock,
  ImageBlockRecord: ImageBlock,
  ReviewRecord: ReviewBlock,
  ListPageBlockRecord: ListWithIconsBlock,
  TestimonialsBlockRecord: TestimonialsBlock,
  RecipeTeaserBlockRecord: RecipeTeaserBlock,
  CalloutBlockRecord: CalloutBlock,
}

function DatoRichText({ richText, cta }) {
  return richText.map(({ __typename: type, ...props }, index) => {
    const Block = blocks[type]

    return <Block cta={cta} {...props} key={index} />
  })
}

DatoRichText.propTypes = {
  richText: PropTypes.array,
  className: PropTypes.string,
  inline: PropTypes.bool,
  cta: PropTypes.object,
}

export default DatoRichText
